import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FavoritesModule } from '../shared/favorite/favorites.module';
import { FavoriteListComponent } from './favorite-list.component';

@NgModule({
  declarations: [FavoriteListComponent],
  imports: [CommonModule, FavoritesModule],
  exports: [FavoriteListComponent],
})
export class FavoriteListModule {}
